export const emailConfig = {
  serviceId: "service_8nymkoi",
  templateId: "template_iyyernj",
  publicKey: "uHTIzHQFAmDibal7P"
};